import React, { useState } from "react";
import ProductTable from "../../components/Product/ProductTable";


const dummyData = Array.from({ length:60 }, (_, i) => ({
 id:i + 1,
  image:"https://img.freepik.com/premium-vector/perfume-bottle-design-glass-beauty-cosmetic-vector-container-female-care-perfume-product-design_41737-682.jpg?w=360",
  name: `Product Name ${i + 1}`,
  price:"$100",
  type:"Unisex",
 status: `Publish`,
}));

const ITEMS_PER_PAGE = 10;

const Product = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  return (
    <div className="flex flex-col w-full gap-4">
  {/* Header */}
  <div className="bg-gray-700 p-3 w-full flex justify-between items-center">
    <h1 className="font-bold text-[1.3rem]">Manage Product Categories</h1>
    <button className="p-2 bg-green-500 rounded-lg">
           Add Product
    </button>
  </div>

  {/* Content */}
  <div className="p-2 w-full bg-gray-700">
    <ProductTable
      data={dummyData.slice(startIndex, endIndex)}
      currentPage={currentPage}
      totalPages={Math.ceil(dummyData.length / ITEMS_PER_PAGE)}
      onPageChange={handlePageChange}
    />
  </div>
</div>

  );
};

export default Product;
